/* 
  START: you can define custom functions within this area
  v v v v v v v v v v v v v v v v v v v v v v v v v v v
*/


function bindCookiePrefsClick() {
    var cookielink = document.querySelector('a[href="#CookiePreferences"]');
    if (cookielink) {
        cookielink.addEventListener('click', openCookiePrefs, false);
    }
}
function openCookiePrefs(e) {
    e.preventDefault();
    if (typeof OneTrust !== "undefined" && typeof OneTrust.ToggleInfoDisplay === "function") {
        OneTrust.ToggleInfoDisplay();
    } else {
        console.warn('OneTrust is not loaded yet.');
    }
    return false;
}

// Pass consent selections from OneTrust to Shopify
function listenForConsentUpdates() {
  window.addEventListener("OneTrustGroupsUpdated", otEvent => {
    var shopifyConsentGroups = {
      "analytics": otEvent.detail.includes('C0002'),
      "preferences": otEvent.detail.includes('C0003'),
      "marketing": otEvent.detail.includes('C0004'),
      "sale_of_data": otEvent.detail.includes('C0004')
    };
    window.Shopify.customerPrivacy.setTrackingConsent(shopifyConsentGroups, () => {
      var updatedConsent = window.Shopify.customerPrivacy.currentVisitorConsent(); 
      window.console.log('~~~~updated Shopify Consent', updatedConsent);
    });    
  });
}

function lazyLoadVideos() {
  theme.utils.libraryLoader('lozad', theme.libraries.lozad, () => {
    if (typeof lozad !== "undefined"){
      const observer = lozad('.lozad', {
        threshold: 0.1,
        loaded: function(el) {
            if (el.nodeName.toLowerCase() === 'video') {
                if (el.childNodes) {
                    var childs = el.childNodes;
                    for (var i = 1; i < childs.length - 1; i++) {
                        if (childs[i].nodeName.toLowerCase() === 'source') {
                            childs[i].src = childs[i].getAttribute('data-src');
                        }
                    }
                    el.load();
                    el.setAttribute('autoplay', ''); // Or el.autoplay = true;
                }
            }
        }
      });
      observer.observe();
    }
  });
}

/* Add International Market Class for Promo Hiding */
function addInternationalMarketClass() {
  const excludedCountries = ["US", "CA", "MX"];

  function applyInternationalClass() {
    const countryElement = document.querySelector(
      "#md-footer-selector__country-popup[data-country]"
    );

    if (!countryElement) {
      return;
    }

    const country = countryElement.getAttribute("data-country");

    document.body.classList.toggle(
      "international-market",
      !excludedCountries.includes(country)
    );

    //console.log("International market check:", country);
    //console.log("international-market:", document.body.classList.contains("international-market"));
  }

  // Try immediately
  applyInternationalClass();

  // Re-run when the selector is injected/updated
  const observer = new MutationObserver(() => {
    applyInternationalClass();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["data-country"]
  });
}

/* PLP sticky filter bar */
function initPLPStickyNav() {
  var collectionNavBar = $('.navigation--root[data-sticky="true"]');
  let plpNavTop = collectionNavBar.offset().top;
  
  function plpstickynavbar() {
    var annHeight = document.documentElement.style.getPropertyValue('--announcement-height').replace('px', '');
    var hdrHeight = document.documentElement.style.getPropertyValue('--header-height').replace('px', '');
    var scrollTrigger = (window.scrollY + parseInt(annHeight) + parseInt(hdrHeight));
    
    var collectionNavBar = $('.navigation--root[data-sticky="true"]');
    var persistentBanner = $('.persistent-banner');

    if (scrollTrigger >= plpNavTop) {
      collectionNavBar.addClass('is-stuck');
      persistentBanner.addClass('hide-persistent');
    } else {
      collectionNavBar.removeClass('is-stuck');
      persistentBanner.removeClass('hide-persistent');
    }
  }
  plpstickynavbar();
  window.addEventListener('scroll', plpstickynavbar);
}
/* END: PLP sticky filter bar */


function accessibilityFixes() {
  document.addEventListener('keydown', function(e) {
    var button = e.target.closest('[role="button"][tabindex="0"]');

    if (!button) return;

    if (e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault(); // prevents page scroll
    }

    if (e.key === 'Enter') {
      e.preventDefault();
      button.click();
    }
  });

  document.addEventListener('keyup', function(e) {
    var button = e.target.closest('[role="button"][tabindex="0"]');

    if (!button) return;

    if (e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      button.click();
    }
  });
}

/* set up custom ElevarDataLayer events */
function bindCustomElevarEvents() {

  /** 
   * Optimove in GTM needs a "cart_empty" event
   * sent only when the cart goes from 1 or more to Zero
  */
  window.on('theme:cart:quantityUpdated', ({ detail: data }) => {
    if (data.items_removed && data.items_removed.length) {
      if (data.item_count == 0) {
        window.ElevarDataLayer.push({ event: "cart_empty" });
      }
    }
  });
}

function initFooterSelectorA11yFix() {
  var link = document.querySelector('#md-footer-selector__country-popup a');
  if (link) {
    link.setAttribute('role', 'button');
    link.setAttribute('tabindex', '0');
  }
}

function initLocationModalListboxA11yFix() {
  function applyFix() {
    var countryList = document.getElementById('orbeCountryList');
    var languageList = document.getElementById('orbeLanguageList');

    if (countryList) {
      countryList.setAttribute('aria-labelledby', 'label-md-form__country-code');
    }

    if (languageList) {
      languageList.setAttribute('aria-labelledby', 'label-md-form__select__language');
    }
  }

  applyFix();

  var observer = new MutationObserver(applyFix);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function initLocationModalLanguageA11yFix() {
  function applyFix() {
    // Country options
    document.querySelectorAll('#orbeCountryList li').forEach(function(option) {

      var isSelected = option.querySelector('[aria-current="true"]');

      option.setAttribute(
        'aria-selected',
        isSelected ? 'true' : 'false'
      );
    });

    // Language options
    document.querySelectorAll('#orbeLanguageList li').forEach(function(option) {

      option.setAttribute('role', 'option');

      if (!option.id) {
        var locale = option.getAttribute('data-locale');
        if (locale) {
          option.id = 'orbe-language-' + locale;
        }
      }

      var isSelected = option.querySelector('[aria-current="true"]');

      option.setAttribute(
        'aria-selected',
        isSelected ? 'true' : 'false'
      );
    });
  }

  applyFix();

  new MutationObserver(applyFix).observe(document.body, {
    childList: true,
    subtree: true
  });
}

/** quickshop **/
(function () {
  if (window.__productTileMobileQuickshopInit) return;
  window.__productTileMobileQuickshopInit = true;

  const CARD_SELECTOR = 'product-tile-root[data-product-item]';
  const SWATCH_SELECTOR = '.radios--swatch-button';
  const SIZE_BTN_SELECTOR = '.product-card-size-hover__btn';
  const MOBILE_TRIGGER_SELECTOR = '.product-card-mobile-qs-trigger';
  const MOBILE_QS_CLOSE_SELECTOR = '[data-mobile-qs-close]';
  const GLOBAL_QS_SELECTOR = '#global-mobile-quickshop';

  const groupCache = new Map();

  function getCard(el) {
    return el.closest(CARD_SELECTOR);
  }

  function getGlobalQuickshop() {
    return document.querySelector(GLOBAL_QS_SELECTOR);
  }

  function openMobileQuickshop() {
    const qs = getGlobalQuickshop();
    if (!qs) return;

    qs.classList.add('is-open');
    qs.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mobile-qs-open');
    document.body.classList.add('mobile-qs-open');
  }

  function closeMobileQuickshop() {
    const qs = getGlobalQuickshop();
    if (!qs) return;

    qs.classList.remove('is-open');
    qs.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mobile-qs-open');
    document.body.classList.remove('mobile-qs-open');
  }

  async function fetchProduct(handle) {
    const response = await fetch(`/products/${handle}.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`Failed to fetch product: ${handle}`);
    return response.json();
  }

  async function getProduct(handle, masterSku) {
    let group = groupCache.get(masterSku);
    if (!group) {
      group = new Map();
      groupCache.set(masterSku, group);
    }
    if (!group.has(handle)) {
      const product = await fetchProduct(handle);
      group.set(handle, product);
    }
    return group.get(handle);
  }

  function getSizeOptionIndex(product) {
    if (!product?.options?.length) return -1;
    return product.options.findIndex(
      (name) => String(name).toLowerCase() === 'size'
    );
  }

  function getSizeLabel(variant, sizeIndex) {
    if (sizeIndex === 0) return variant.option1 || variant.title;
    if (sizeIndex === 1) return variant.option2 || variant.title;
    if (sizeIndex === 2) return variant.option3 || variant.title;
    const parts = String(variant.title || '').split(' / ');
    return parts[parts.length - 1] || variant.title;
  }

  function getCardPriceHTML(card) {
    const priceEl =
      card.querySelector('.js-tile-price') ||
      card.querySelector('.product--price-container');

    return priceEl ? priceEl.innerHTML : '';
  }

  function getCardImageData(card) {
    const img =
      card.querySelector('.product--image img') ||
      card.querySelector('.product--image-wrapper img');

    if (!img) {
      return { src: '', alt: '' };
    }

    return {
      src: img.currentSrc || img.src || '',
      alt: img.alt || ''
    };
  }

  function getCardTitle(card) {
    const el = card.querySelector('.product--title');
    return el ? el.textContent.trim() : '';
  }

  function getCardLink(card) {
    const link = card.querySelector('.product-tile--link[href]');
    return link ? link.href : '#';
  }

  function updateCardSizeButtons(card, product) {
    const sizeIndex = getSizeOptionIndex(product);
    const variants = product.variants || [];

    ['.product-card-size-hover__inner'].forEach((sel) => {
      const wrap = card.querySelector(sel);
      if (!wrap) return;

      wrap.innerHTML = '';

      variants.forEach((variant) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-card-size-hover__btn';
        btn.dataset.variantId = String(variant.id);
        btn.dataset.productHandle = product.handle;
        btn.textContent = getSizeLabel(variant, sizeIndex);
        btn.disabled = !variant.available;
        btn.classList.toggle('is-disabled', !variant.available);
        wrap.appendChild(btn);
      });
    });
  }

  function updateGlobalQuickshopImage(product, fallbackCard) {
    const qs = getGlobalQuickshop();
    const img = qs?.querySelector('.mini-product-image img');
    if (!qs || !img) return;

    let src = product?.featured_image || product?.images?.[0] || '';
    let alt = product?.title || '';

    if (!src && fallbackCard) {
      const fallback = getCardImageData(fallbackCard);
      src = fallback.src;
      alt = fallback.alt;
    }

    if (!src) return;

    img.src = src;
    img.alt = alt || img.alt || '';
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
  }

  function updateGlobalQuickshopTitle(product, fallbackCard) {
    const qs = getGlobalQuickshop();
    const title = qs?.querySelector('.mini-product-title');
    if (!title) return;

    const text = product?.title || (fallbackCard ? getCardTitle(fallbackCard) : '');
    title.textContent = text || '';
  }

  function updateGlobalQuickshopLink(product, fallbackCard) {
    const qs = getGlobalQuickshop();
    const link = qs?.querySelector('.mini-product-url');
    if (!link) return;

    if (product?.url) {
      link.href = product.url;
      return;
    }

    if (fallbackCard) {
      link.href = getCardLink(fallbackCard);
    }
  }

  function updateGlobalQuickshopPrice(card) {
    const qs = getGlobalQuickshop();
    const priceWrap = qs?.querySelector('.js-quickshop-price');
    if (!priceWrap || !card) return;

    priceWrap.innerHTML = getCardPriceHTML(card);
  }

  function updateGlobalQuickshopSizes(product) {
    const qs = getGlobalQuickshop();
    const wrap = qs?.querySelector('.variant-options');
    if (!wrap) return;

    const sizeIndex = getSizeOptionIndex(product);
    const variants = product.variants || [];

    wrap.innerHTML = '';

    variants.forEach((variant) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-card-size-hover__btn single-variant-option';
      btn.dataset.variantId = String(variant.id);
      btn.dataset.productHandle = product.handle;
      btn.textContent = getSizeLabel(variant, sizeIndex);
      btn.disabled = !variant.available;
      btn.classList.toggle('is-disabled', !variant.available);
      wrap.appendChild(btn);
    });
  }

  async function populateGlobalQuickshopFromCard(card) {
    const qs = getGlobalQuickshop();
    if (!qs || !card) return;

    const handle = card.dataset.productHandle;
    const masterSku = card.dataset.masterSku;

    qs.__sourceCard = card;
    qs.dataset.productHandle = handle || '';
    qs.dataset.masterSku = masterSku || '';

    updateGlobalQuickshopPrice(card);
    updateGlobalQuickshopTitle(null, card);
    updateGlobalQuickshopLink(null, card);
    updateGlobalQuickshopImage(null, card);

    if (!handle || !masterSku) return;

    try {
      const product = await getProduct(handle, masterSku);
      updateGlobalQuickshopImage(product, card);
      updateGlobalQuickshopTitle(product, card);
      updateGlobalQuickshopLink(product, card);
      updateGlobalQuickshopSizes(product);
      updateCardSizeButtons(card, product);
    } catch (e) {
      console.error('Failed to populate global quickshop:', e);
    }
  }

  async function onSwatchClick(swatch) {
    const card = getCard(swatch);
    if (!card) return;

    const handle = swatch.dataset.productHandle;
    const masterSku = card.dataset.masterSku;
    if (!handle || !masterSku) return;

    try {
      const product = await getProduct(handle, masterSku);

      card.dataset.productHandle = product.handle || handle;
      updateCardSizeButtons(card, product);

      const qs = getGlobalQuickshop();
      if (qs?.__sourceCard === card) {
        qs.dataset.productHandle = product.handle || handle;
        updateGlobalQuickshopImage(product, card);
        updateGlobalQuickshopTitle(product, card);
        updateGlobalQuickshopLink(product, card);
        updateGlobalQuickshopSizes(product);

        requestAnimationFrame(() => updateGlobalQuickshopPrice(card));
        setTimeout(() => updateGlobalQuickshopPrice(card), 200);
      }
    } catch (e) {
      console.error('Failed to update quickshop content:', e);
    }
  }

  async function addVariantToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;
    if (btn.dataset.loading === 'true') return;

    btn.dataset.loading = 'true';

    try {
      await theme.cart.addItem({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }, variantId);

      closeMobileQuickshop();
      theme.drawer.open('right', 'cart-drawer', btn);
    } catch (error) {
      console.error('Add to cart failed:', error);
    } finally {
      delete btn.dataset.loading;
    }
  }

 document.addEventListener('click', async function (e) {
  const trigger = e.target.closest(MOBILE_TRIGGER_SELECTOR);
  if (trigger) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const card = getCard(trigger);
    if (!card) return;

    await populateGlobalQuickshopFromCard(card);
    openMobileQuickshop();
    return;
  }

  const close = e.target.closest(MOBILE_QS_CLOSE_SELECTOR);
  if (close) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    closeMobileQuickshop();
    return;
  }

  const sizeBtn = e.target.closest(SIZE_BTN_SELECTOR);
  if (sizeBtn) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    addVariantToCart(sizeBtn);
    return;
  }

  const swatch = e.target.closest(SWATCH_SELECTOR);
  if (swatch) {
    onSwatchClick(swatch);
  }
}, true);
})(); 

/** hide klaviyo pop up when quickshop is open **/
function hideKlaviyoWhenQuickshopOpen() {
  const quickshop = document.getElementById('global-mobile-quickshop');
  if (!quickshop) return;

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function isQuickshopOpen() {
    return (
      isMobile() &&
      (
        quickshop.classList.contains('is-open') ||
        quickshop.getAttribute('aria-hidden') === 'false'
      )
    );
  }

  function updateState() {
    if (isQuickshopOpen()) {
      document.documentElement.setAttribute('data-quickshop-open', 'true');
    } else {
      document.documentElement.removeAttribute('data-quickshop-open');
    }
  }

  new MutationObserver(updateState).observe(quickshop, {
    attributes: true,
    attributeFilter: ['class', 'aria-hidden'],
  });

  window.addEventListener('resize', updateState);
  updateState();
}

function initProductTileQuickshopContrast() {
  const TILE_SELECTOR = 'product-tile-root[data-product-item]';
  const IMG_SELECTOR = '.product--image img';
  const TRIGGER_SELECTOR = '.product-card-mobile-qs-trigger';

  function getBrightness(img, sampleSize = 70) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { willReadFrequently: true });

    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;

    ctx.drawImage(img, 0, 0);

    const x = Math.max(canvas.width - sampleSize, 0);
    const y = Math.max(canvas.height - sampleSize, 0);
    const data = ctx.getImageData(x, y, sampleSize, sampleSize).data;

    let total = 0;

    for (let i = 0; i < data.length; i += 4) {
      total += 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
    }

    return total / (data.length / 4);
  }

  function processTile(tile) {
    if (tile.dataset.qsContrastChecked === 'true') return;

    const img = tile.querySelector(IMG_SELECTOR);
    const trigger = tile.querySelector(TRIGGER_SELECTOR);

    if (!img || !trigger) return;

    function run() {
      try {
        const brightness = getBrightness(img);

        tile.classList.toggle('mobile-qs-dark-image', brightness < 160);
        tile.classList.toggle('mobile-qs-light-image', brightness >= 160);
      } catch (e) {
        tile.classList.add('mobile-qs-light-image');
      }

      tile.dataset.qsContrastChecked = 'true';
    }

    if (img.complete && img.naturalWidth) {
      run();
    } else {
      img.addEventListener('load', run, { once: true });
    }
  }

  function processAllTiles() {
    document.querySelectorAll(TILE_SELECTOR).forEach(processTile);
  }

  processAllTiles();

  let queued = false;

  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;

    requestAnimationFrame(() => {
      processAllTiles();
      queued = false;
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

}

/* auto-open the Yotpo write-a-review modal on PDPs when ?open_review=true */
function openYotpoReviewModalFromQueryParam() {
  if (!document.body.classList.contains('template--product')) return;

  var params = new URLSearchParams(window.location.search);
  if (params.get('open_review') !== 'true') return;

  var tries = 0;
  var maxTries = 40; // 40 * 500ms = 20s

  var isReviewFormOpen = function () {
    var modal = document.getElementById('newReviewFormModal');
    return !!modal && modal.style.display !== 'none';
  };

  // Yotpo can take a while to finish loading, so show a lightweight overlay
  // while we wait instead of leaving the page looking unresponsive
  var loadingOverlay = null;

  function showLoadingOverlay() {
    var overlay = document.createElement('div');
    overlay.className = 'review-loading-overlay';
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');
    overlay.setAttribute('aria-label', 'Loading write a review form');

    var card = document.createElement('div');
    card.className = 'review-loading-overlay__card';

    var spinner = document.createElement('div');
    spinner.className = 'review-loading-overlay__spinner';

    var text = document.createElement('div');
    text.className = 'review-loading-overlay__text';
    text.textContent = 'Loading write a review form...';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'review-loading-overlay__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', hideLoadingOverlay);

    card.appendChild(closeBtn);
    card.appendChild(spinner);
    card.appendChild(text);
    overlay.appendChild(card);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    loadingOverlay = overlay;
  }

  function hideLoadingOverlay() {
    if (!loadingOverlay) return;
    loadingOverlay.remove();
    document.body.style.overflow = '';
    loadingOverlay = null;
  }

  var tryOpen = function () {
    tries++;

    if (isReviewFormOpen()) {
      hideLoadingOverlay();
      return true;
    }

    var el =
      document.querySelector('.yotpo-new-review-btn-wrapper') ||
      document.querySelector('.yotpo .write-review') ||
      document.querySelector('[data-yotpo-button="write-review"]');

    if (el) el.click();

    var doneRetrying = tries >= maxTries;
    if (doneRetrying) hideLoadingOverlay();
    return doneRetrying;
  };

  showLoadingOverlay();

  var interval = setInterval(function () {
    if (tryOpen()) clearInterval(interval);
  }, 500);
}

/* 
  ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
  END: area to define custom functions
  =====================================================
*/


/* 
  jQueryIsReady is just like like $(document).ready() - put your jQuery code here to avoid timing errors
*/
var jQueryIsReady = function() {
  /* 
    START: add any jQuery code or call functions that DEPEND on jQuery within this block
    (don't define functions here, just call them from here)
    v v v v v v v v v v v v v v v v v v v v v v v v v v v
  */
  
  accessibilityFixes();

  if ( $('.navigation--root[data-sticky="true"]').length ) {
    initPLPStickyNav();
  }
  
  
  /* 
    ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
    END: code that DEPENDS on jQuery goes in the area above
  */
}
// end jQueryIsReady
// ========================================================================


/* 
  dkCustomInit is a function that runs immediately on page load, 
  but may finish before jQuery is fully loaded
*/
function dkCustomInit() {
  var checkJquery = function(){
    if (typeof jQuery === "undefined"){
        return false;
    } else {
        clearTimeout(jqInterval);
        jQueryIsReady();
    }
  }
  var jqInterval = setInterval(checkJquery,1000);

  /* 
    START: call any functions that DON'T depend on jQuery within this block
    (don't define functions here, just call them from here)
    v v v v v v v v v v v v v v v v v v v v v v v v v v v
  */
 
 
  // Pass consent selections from OneTrust to Shopify
  listenForConsentUpdates();

  bindCookiePrefsClick();  
  bindCustomElevarEvents();

  openYotpoReviewModalFromQueryParam();
  addInternationalMarketClass();
  hideKlaviyoWhenQuickshopOpen();
  
  lazyLoadVideos();

  // Footer selector a11y fix
  initFooterSelectorA11yFix();

  // Location modal listbox a11y fix
  initLocationModalListboxA11yFix();

  // Language modal listbox a11y fix
  initLocationModalLanguageA11yFix();

  
  /* 
    ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
    END: functions that DON'T depend on jQuery
    =====================================================
  */ 
}
// end dkCustomInit
// ========================================================================


/* LEAVE THIS AT THE BOTTOM OF THE FILE AND DO NOT EDIT */
if (/complete|interactive|loaded/.test(document.readyState)) {
    dkCustomInit();
} else {
    document.addEventListener('DOMContentLoaded', dkCustomInit);
}
